import {NotificationTriggerType} from "./notificationTriggerType";

export default class NotificationTrigger {
  triggerOn: NotificationTriggerType;
  targetClientId: string;
  constructor(triggerOn, targetClientId) {
    this.triggerOn = triggerOn;
    this.targetClientId = targetClientId;
  }

  toString() {
    if (this.targetClientId) {
      return `${this.triggerOn}_${this.targetClientId}`;
    } else {
      return this.triggerOn.toString();
    }
  }

  matches(other) {
    const myClientId = this.targetClientId || "";
    const otherClientId = other.targetClientId || "";
    return this.triggerOn === other.triggerOn && myClientId === otherClientId;
  }
}